<template>
    <div class="main-container billing">
        <div class="people-error" role="alert" v-if="status === 'billing_errors'">
            <div class="alert-badge">
                <i class="far fa-exclamation-triangle"></i>
            </div>
            <div class="alert-details">
                <p class="alert-message">
                    {{ error_message }}
                </p>
            </div>
            <ul class="error-items" v-if="billing_errors">
                <li v-for="error in billing_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="people-container p-5">
            <h2>Billing Address</h2>
            <div class="flex flex-wrap">
                <div class="md:pr-2 w-full md:w-1/2">
                    <label>First Name</label>
                    <input type="text" v-model="billing.first_name" />
                </div>
                <div class="md:pl-2 w-full md:w-1/2">
                    <label>Last Name</label>
                    <input type="text" v-model="billing.last_name" />
                </div>
                <div class="w-full">
                    <label>Email</label>
                    <input type="email" autocomplete="email" v-model="billing.email" />
                </div>
                <div class="w-full">
                    <label>Phone</label>
                    <input type="text" autocomplete="phone" v-model="billing.phone" @input="formatPhoneNumber" />
                </div>
                <div class="w-full">
                    <label>Company Name</label>
                    <input type="text" v-model="billing.company" />
                </div>
                <div class="md:pr-2 w-full md:w-1/2">
                    <label>Address</label>
                    <input type="text" v-model="billing.street_address" />
                </div>
                <div class="md:pl-2 w-full md:w-1/2">
                    <label>Apartment, Suite, Unit Etc.</label>
                    <input type="text" v-model="billing.suite" />
                </div>
                <div class="w-full">
                    <label>City</label>
                    <input type="text" v-model="billing.city" />
                </div>
                <div class="md:pr-2 w-full md:w-1/2">
                    <label>State</label>
                    <select-state v-model="billing.state_code"></select-state>
                </div>
                <div class="md:pl-2 w-full md:w-1/2">
                    <label>Postal Code</label>
                    <input type="text" v-model="billing.postal_code" />
                </div>
            </div>
        </div>
        <div class="flex justify-between items-center">
            <button-back class="primary-outline" to="/cart"></button-back>
            <button class="primary" v-on:click="saveBilling" :disabled="status === 'validating_address'">
                <i class="fad fa-spinner-third fa-spin" v-if="status === 'validating_address'"></i>
                {{ button_contiue_text }}
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ButtonBack from "@/components/ButtonBack.vue";
import SelectState from "@/components/SelectState.vue";

export default {
    name: "BillingView",
    components: {
        ButtonBack,
        SelectState,
    },
    data() {
        return {
            billing: sessionStorage.people_billing
                ? JSON.parse(sessionStorage.people_billing)
                : {
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                    company: "",
                    street_address: "",
                    suite: "",
                    city: "",
                    state_code: "IN",
                    postal_code: "",
                },
            billing_errors: null,
            button_contiue_text: "Continue",
            status: null,
        };
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 5 });
    },
    methods: {
        formatPhoneNumber(event) {
            let input = event.target.value.replace(/\D/g, '');
            if (input.length > 10) {
                input = input.substring(0, 10);
            }
            const area_code = input.substring(0, 3);
            const middle = input.substring(3, 6);
            const last = input.substring(6, 10);

            if (input.length > 6) {
                this.billing.phone = `(${area_code}) ${middle}-${last}`;
            } else if (input.length > 3) {
                this.billing.phone = `(${area_code}) ${middle}`;
            } else if (input.length > 0) {
                this.billing.phone = `(${area_code}`;
            } else {
                this.billing.phone = '';
            }
        },
        saveBilling() {
            const vue = this;
            this.status = "validating_address";
            this.button_contiue_text = "Validating Address";

            axios
                .post(ibj_people_payment_api_url + "api/validation/billing", this.billing)
                .then(function (response) {
                    sessionStorage.people_billing = JSON.stringify(vue.billing);
                    const router = vue.$router;
                    router.push("/payment");
                })
                .catch(function (error) {
                    sessionStorage.removeItem("people_billing");
                    vue.status = "billing_errors";
                    vue.error_message = "Oops, we have a problem:";
                    vue.billing_errors = error.response.data.errors;
                    vue.button_contiue_text = "Continue";
                    scroll(0, 0);
                });
        },
    },
};
</script>
